import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { pageRouteUrls } from "../helper/pageRouteUrls";

const SearchHeader = () => {
    const [keyword, setKeyword] = useState("");
    const navigate = useNavigate();

    const doSearch = (e: React.FormEvent) => {
        e.preventDefault(); 
        const trimmed = keyword.trim();
        if (trimmed) 
            navigate( `${pageRouteUrls.Search()}?query=${encodeURIComponent(trimmed)}`);
        else
            navigate( pageRouteUrls.Search());
    };

    return (
        <form onSubmit={doSearch}>
            <input
                type="text"
                placeholder="Search here"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
            />
            <button type="submit">
                <i className="icofont-search-1"></i>
            </button>
        </form>
    );
};

export default SearchHeader;
